<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-engine-warning" id="ico"></i>
		<h1 style="display: inline-block;">Botón Ciudadano</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row" *ngIf="panel">
			<div class="col col-sm-12 col-md-7 col-lg-7 contenido">
				<i style="margin-right: 3px;" class="far fa-credit-card col-md-1"></i><b>Id:</b>&nbsp;{{panel.id}}<br>
				<i style="margin-right: 3px;" class="fal fa-barcode-alt col-md-1"></i><b>Número Serie:</b>&nbsp;{{panel.numeroSerie}}<br>
				<i style="margin-right: 3px;" class="far fa-paperclip col-md-1"></i><b>Descripcion:</b>&nbsp;{{panel.descripcion}}<br>
				<i style="margin-right: 3px;" class="fas fa-bars col-md-1"></i><b>Nombre:</b>&nbsp;{{panel.nombre}} m3<br>
				<i style="margin-right: 3px;" class="fal fa-weight col-md-1"></i><b>Modelo:</b>&nbsp;{{panel.modelo}}<br>
				<i style="margin-right: 3px;" class="fas fa-sort-numeric-down col-md-1"></i><b>Latitud:</b>&nbsp;{{panel.lat | number}}<br>
				<i style="margin-right: 3px;" class="fas fa-sort-numeric-up col-md-1"></i><b>Longitud:</b>&nbsp;{{panel.lng | number}}<br>
				<i style="margin-right: 3px;" class="fas fa-user col-md-1"></i><b>Nombre del Contacto:</b> {{panel.nombreContacto}} <br>
				<i style="margin-right: 3px;" class="fas fa-phone col-md-1"></i><b>Teléfono del Contacto:</b> {{panel.telefonoContacto}} <br>
				<i style="margin-right: 3px;" class="fas fa-barcode col-md-1"></i><b>Código de Protocolo:</b> {{panel.codigoProtocolo}} <br>
				<i style="margin-right: 3px;" class="fal fa-map-pin col-md-1"></i><b>Dirección:</b> {{direccion}} <br>
				
			</div>
			<div class="col col-sm-12 col-md-5 col-lg-5 contenido">
				<img [src]="panel.imagen" style="width: 100%;" loading="lazy">
			</div>
		</div>
		<div class="row">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button class="btnPopup ubicar mt-3" mat-raised-button (click)="ubicarPanel()"><i id="btnIco"
						class="fal fa-binoculars"></i>&nbsp;Ubicar</button>&nbsp;
				<button class="btnPopup historico  mt-3" mat-raised-button (click)="historicoPanel()"><i id="btnIco"
						class="fal fa-calendar-alt"></i>&nbsp;Histórico</button>&nbsp;
				<button class="btnPopup streetView  mt-3" mat-raised-button (click)="verStreet()"><i id="btnIco"
						class="fal fa-street-view"></i>&nbsp;Street View</button>&nbsp;
			</div>
		</div>
	</div>
</div>
